import type { BoxInfo, BoxType } from '@deepcloud/api-deep-box'

export function useBoxInfo(box: ComputedRef<BoxInfo>) {
  function hasBoxRelationByBoxType(boxType: BoxType) {
    return box.value?.relations?.filter((a) => a.boxType === boxType).length > 0
  }

  return {
    hasBoxRelationByBoxType,
  }
}
